import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"

const ParameterDatalakeTipoEstruturasDFsCVMTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "ID_Tipo_Estrutura": null,
            "TipoEstrutura": null,
            "DescricaoEstrutura": null,
            "ValorEstrutura": null,
            "InicioVigencia": dayjs().format(DATE_FORMAT),
            "FimVigencia": dayjs().format(DATE_FORMAT),
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, ID_Tipo_Estrutura, TipoEstrutura, DescricaoEstrutura, ValorEstrutura, InicioVigencia, FimVigencia
            } = newRow

        const body = {
            "ID_Tipo_Estrutura": ID_Tipo_Estrutura,
            "TipoEstrutura": TipoEstrutura,
            "DescricaoEstrutura": DescricaoEstrutura,
            "ValorEstrutura": ValorEstrutura,
            "InicioVigencia": InicioVigencia,
            "FimVigencia": FimVigencia
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'ID_Tipo_Estrutura',
            headerName: 'ID_Tipo_Estrutura',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoEstrutura',
            headerName: 'TipoEstrutura',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DescricaoEstrutura',
            headerName: 'DescricaoEstrutura',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ValorEstrutura',
            headerName: 'ValorEstrutura',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'InicioVigencia',
            headerName: 'InicioVigencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ row }) => row.InicioVigencia? dayjs(row.InicioVigencia, DATE_FORMAT).toDate(): null,
        },
        {
            field: 'FimVigencia',
            headerName: 'FimVigencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ row }) => row.FimVigencia ? dayjs(row.FimVigencia, DATE_FORMAT).toDate(): null,
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeTipoEstruturasDFsCVMTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeTipoEstruturasDFsCVMTable